module.exports = __webpack_public_path__ + "static/media/spa-header-bg.fd0ee30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/appInvite/spa-header-bg.png
// module id = 1912
// module chunks = 6